import createIcon from '../../createIcon';

/**
 * @component @name SettingsAccessibility
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAuNSA0QzE3Ljg5IDQuNyAxNC44MyA1IDEyIDVDOS4xNyA1IDYuMTEgNC43IDMuNSA0TDMgNkM0Ljg2IDYuNSA3IDYuODMgOSA3VjE5SDExVjEzSDEzVjE5SDE1VjdDMTcgNi44MyAxOS4xNCA2LjUgMjEgNkwyMC41IDRaTTEyIDRDMTMuMSA0IDE0IDMuMSAxNCAyQzE0IDAuOSAxMy4xIDAgMTIgMEMxMC45IDAgMTAgMC45IDEwIDJDMTAgMy4xIDEwLjkgNCAxMiA0Wk03IDI0SDlWMjJIN1YyNFpNMTEgMjRIMTNWMjJIMTFWMjRaTTE1IDI0SDE3VjIySDE1VjI0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SettingsAccessibility = createIcon('SettingsAccessibility', [
  [
    'path',
    {
      d: 'M20.5 4C17.89 4.7 14.83 5 12 5C9.17 5 6.11 4.7 3.5 4L3 6C4.86 6.5 7 6.83 9 7V19H11V13H13V19H15V7C17 6.83 19.14 6.5 21 6L20.5 4ZM12 4C13.1 4 14 3.1 14 2C14 0.9 13.1 0 12 0C10.9 0 10 0.9 10 2C10 3.1 10.9 4 12 4ZM7 24H9V22H7V24ZM11 24H13V22H11V24ZM15 24H17V22H15V24Z',
      key: 'v0fv1s',
    },
  ],
]);

export default SettingsAccessibility;
